import { Company, Id } from '@nextforce/api'
import { StackNavigationProp } from '@react-navigation/stack'
import { ListItem, Text, makeStyles } from '@rneui/themed'
import { font } from 'app/theme'
import { HomeStackParamList } from 'home/stack/types'
import React from 'react'
import { View } from 'react-native'
import {
  DropdownItem,
  DropdownItemComponentProps,
  DropdownSection,
} from 'shared/components/dropdown'
import { showHeaderButtonDropdown } from 'shared/header/header_button_dropdown'

export interface CompanyDropdownItem extends DropdownItem {
  company?: Company
}

interface showCompanyHeaderDropdownProps {
  companies: Company[] | undefined
  activeCompanyId: Id | undefined
  setActiveCompanyId?: (id: Id | undefined) => void
}

export function showCompanyHeaderDropdown<
  RouteName extends keyof HomeStackParamList
>(
  navigation: StackNavigationProp<HomeStackParamList, RouteName>,
  {
    companies,
    activeCompanyId,
    setActiveCompanyId,
  }: showCompanyHeaderDropdownProps,
  onCompanySelected?: (id: Id) => void
) {
  const hideDownArrow = true
  const hideSideStepButtons = true

  return showHeaderButtonDropdown(
    navigation,
    getCompanySections(companies, activeCompanyId),
    activeCompanyId,
    onSelection,
    DropdownCompanyItemComponent,
    hideDownArrow,
    hideSideStepButtons,
    { name: 'building', type: 'font-awesome-5', solid: true }
  )

  function onSelection(id: Id) {
    setActiveCompanyId?.(id)
    onCompanySelected?.(id)
  }
}

export function getCompanySections(
  companies: Company[] | undefined,
  activeCompanyId: Id | undefined
): DropdownSection<CompanyDropdownItem>[] {
  if (!companies || !activeCompanyId) {
    return []
  }

  const items: CompanyDropdownItem[] = companies.map(s => ({
    name: `${s.name}`,
    id: s.id,
    company: s,
  }))

  return [
    {
      data: items,
    },
  ]
}

export function DropdownCompanyItemComponent({
  item,
  selected,
}: DropdownItemComponentProps<CompanyDropdownItem>) {
  const styles = useStyles()

  return (
    <View style={styles.item}>
      <CompanyItem company={item.company} isSelected={selected} />
    </View>
  )
}

interface Props {
  company?: Company
  isSelected: boolean
  onSelect?: (company: Company) => void
}

export function CompanyItem({ company, isSelected, onSelect }: Props) {
  const styles = useStyles()

  return (
    <ListItem containerStyle={styles.container}>
      <ListItem.CheckBox
        containerStyle={styles.checkbox}
        checked={isSelected}
        checkedIcon="check"
        uncheckedIcon=""
        title={
          company ? (
            <View style={styles.store}>
              <Text
                style={styles.name}
                numberOfLines={1}
              >{`${company.name}`}</Text>
            </View>
          ) : (
            ''
          )
        }
        disabled={!onSelect}
        onPress={
          onSelect && company
            ? () => {
                company && onSelect(company)
              }
            : undefined
        }
      />
    </ListItem>
  )
}

const useStyles = makeStyles(theme => ({
  item: {
    flex: 1,
    marginRight: 20,
    width: 200,
  },
  moreText: {
    marginLeft: 10,
    marginTop: 15,
    fontSize: 17,
  },
  container: {
    padding: 7,
  },
  checkbox: {
    backgroundColor: theme.colors?.white,
    borderWidth: 0,
    width: '100%',
  },
  store: {
    marginLeft: 7,
  },
  name: {
    fontSize: 13,
    fontFamily: font.bold,
    color: theme.colors?.black,
  },
  text: {
    fontSize: 13,
    color: theme.colors?.black,
  },
}))
